<template>
  <validation-observer ref="EditForm" #default="{ invalid }">
    <b-form @submit.prevent="editTask()">
      <b-row>
        <b-col md="12">
          <b-form-group label="Title" label-for="task_title">
            <validation-provider #default="{ errors }" name="Title" vid="Title" rules="required">
              <b-form-input id="task_title" placeholder="Title" required v-model="task.title" :disabled="isView"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
       
        <b-col md="4">
          <b-form-group label="Milestone" label-for="milestones">
            <b-form-select id="milestones" @change="selectedMilestone" v-model="task.milestonesId" :disabled="isView || currentMilestoneId != null" :options="milestonesList" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider #default="{ errors }" name="State Date" vid="Start Date" rules="required">
              <b-form-datepicker id="start_date"  class="mb-1" v-model="task.startDate" :disabled="isView" 
              :date-format-options="{ day: '2-digit', month: 'short', year: 'numeric' }"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider #default="{ errors }" name="End Date" vid="End Date" rules="required">
              <b-form-datepicker id="end_date" :min="task.startDate" placeholder="Choose a date"  :disabled="isView"
                v-model="task.endDate" :date-format-options="{ day: '2-digit', month: 'short', year: 'numeric' }"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Assignee" label-for="assignee">
            <validation-provider #default="{ errors }" name="Assignee" vid="Assignee" rules="required">
              <b-form-select v-model="task.assignee" :options="assignee_options"  :disabled="isView"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Priority" label-for="priority">
            <b-form-select v-model="task.priority" :options="priorityOptions" required  :disabled="isView"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status" label-for="status">
            <b-form-select v-model="task.status" :options="statusOptions" required  :disabled="isView"/>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Comment" label-for="task_description">
            <b-form-textarea id="task_description" placeholder="Comment" rows="3" v-model="task.description"  :disabled="isView"/>
          </b-form-group>
        </b-col>
        
        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between" v-if="!isView">
          <b-button type="button" @click="editTask" variant="primary">Submit</b-button>
        </b-col>


      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { customError, customLoader, customSwal, fnSortingDropdown } from "@/libs/customFn";
import '@/libs/customValidation';

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    milestonesId:{
      type: String,
      default: () => null,
    },
    isView:{
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      assetCode: "",
      currentDate: new Date().toISOString().split('T')[0],
      task_title: "Title 1",
      task_description: "Task description will appear here",
      task_start_date: "2024-06-16",
      task_end_date: "2024-06-25",
      purchaseDate: null,
      currentMilestoneId: this.milestonesId,
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      assignee_selected: 1,
      priority_selected: 2,
      status_selected: 2,
      costPerHour: 0,
      priorityOptions: [
        { value: 'NOTSPECIFIED', text: "Not Specified" },
        { value: 'LOW', text: "Low" },
        { value: 'MEDIUM', text: "Medium" },
        { value: 'HIGH', text: "High" },
      ],
      statusOptions: [
        { value: 'NOTSTARTED', text: "Not Started" },
        { value: 'INPROGRESS', text: "In Progress" },
        { value: 'ONHOLD', text: "On Hold" },
        { value: 'COMPLETED', text: "Completed" },
      ],

      assignee_options: [],
      milestonesList: [],
    };
  },

  methods: {
    ...mapActions("projectModule", ["getProjectAssigneesAction", "addProjectTaskAction", "updateProjectTaskAction", "getProjectMilestoneAction"]),
    async editTask() {
      let isValid = await this.$refs.EditForm.validate();
      if (isValid) {

        let loader = this.$swal({
          title: 'Processing...',
          text: 'Please wait while the task is being updated',
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });
        //const formattedStartDate = this.task.startDate ? (new Date(this.task.startDate).toISOString()) : null;
        //const formattedEndDate = this.task.endDate ? (new Date(this.task.endDate).toISOString()) : null;
          console.log("tasks", this.task);
        let payload = {
          projectId: this.$route.params.id,
          //...this.task,
           taskId: this.task.id,
           description: this.task.description,
           milestonesId: this.task.milestonesId,
           priority: this.task.priority,
           status: this.task.status,
           title: this.task.title,
           assignee: this.task.assignee,
           assigneeName: this.assigneeName,
           startDate: this.task.startDate,
           endDate: this.task.endDate
        };
        console.log("payloadsssss", payload);
        await this.updateProjectTaskAction(payload).then(() => {
          loader.close();
          this.success();
          //window.location.reload();
        }).catch(error => {
          loader.close();
          this.error(error.response.data);
        });
      }
    },
    selectedMilestone() {
      console.log("list",this.milestones);
    const milestoneselect = this.milestones.find(
      (milestone) => milestone.id === this.task.milestonesId
    );
    console.log("milestoneselect",milestoneselect);
    
    if (milestoneselect) {
      this.task.startDate = milestoneselect.startDate;
      this.task.endDate = milestoneselect.endDate;
    }
  },
    success() {
      this.$swal({
        title: 'Task Added!',
        text: 'You have successfully updated the Task!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$emit('taskUpdated');
        }
      })
    },
    error(data) {
      this.$swal('Error!', this.getErrorString(data) || 'Failed!', 'error');
    },
    getErrorString(data) {
      let msg = "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },

  },

  computed: {
    ...mapGetters("projectModule", {
      assignees: "assignees",
      loading: "loading",
      milestones: "milestones",
    }),
    assigneeName() {
      const assignee = this.assignee_options.find(option => option.value === this.task.assignee);
      return assignee ? assignee.text : '';
    }
  },

  async mounted() {
    await this.getProjectAssigneesAction().then(() => {
      console.log(this.assignees)
      this.assignee_options = this.assignees.map((assignee) => ({
        value: assignee.id,
        text: `${assignee.firstName} ${assignee.lastName}`,
      }));
    });

    await this.getProjectMilestoneAction(this.task.projectId).then((res) => {
      this.milestonesList = fnSortingDropdown(this.milestones, 'asc', 'name').map((v, i) => { return { value: v.id, text: v.name }; })
    })
  },
};
</script>
